import { render, staticRenderFns } from "./WorkHeaderDropdownAccnt.vue?vue&type=template&id=ebf284a6&scoped=true&"
import script from "./WorkHeaderDropdownAccnt.vue?vue&type=script&lang=js&"
export * from "./WorkHeaderDropdownAccnt.vue?vue&type=script&lang=js&"
import style0 from "./WorkHeaderDropdownAccnt.vue?vue&type=style&index=0&id=ebf284a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf284a6",
  null
  
)

export default component.exports